<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="isShowCourseSelect")
            label.fields__label.fields__label--small  {{ $i18n.tc('fields.fields_course', 0) }}
            cs-multiselect.fields__input(
                :multiple="true",
                :options="courses",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                hide-selected=true
                :loading="loadingCourses",
                close-on-select=false,
                @open="getCourses",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.courses"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_courseNotFound') }}
        .fields__element
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_school', 0) }}
            cs-input.fields__input(
                type="text",
                :placeholder="$i18n.t('fields.list_schoolPlaceholder')",
                v-model="form.name"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('school.school_form_address') }}
            cs-search-input(
                type="text",
                :placeholder="$i18n.t('school.school_form_address')",
                v-model="form.address"
                @search="sendForm"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_accountStatus') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="accountStatuses",
                :show-labels="false",
                :allow-empty="true",
                :custom-label="getAccountStatusName",
                :placeholder="$i18n.t('fields.fields_anyStatus')",
                v-model="form.accountStatus",
                :searchable="false"
            )
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="orderSchoolTransactions",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.orderSchoolTransactions"
            )
        .fields__element
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_period') }}
            cs-datepicker.fields__input.datepicker-input-container--no-margin(
                :language="user.locale",
                :disabled-dates="dateTo ? {from: new Date(dateTo)} : {}",
                :format="customFormatter",
                v-model="dateFrom"
            )
            .fields__divider —
            cs-datepicker.fields__input.datepicker-input-container--no-margin(
                :language="user.locale",
                :disabled-dates="dateFrom ? {to: new Date(dateFrom)} : {}",
                :format="customFormatter",
                v-model="dateTo"
            )
        .fields__element
            .fields__period-buttons-container
                a.fields__period-button(
                    v-for="periodValue in periods"
                    href="javascript://"
                    @click="setPeriod(periodValue)"
                )
                    | {{ $i18n.t(`fields.fields_${periodValue}Period`) }}
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import searchParamsStore from '../../utils/searchParamsStore';
    import statusFieldMixin from '../../utils/statusFieldMixin';
    import searchFieldsMixin from '../../../../utils/searchFieldsMixin';
    import moment from 'moment';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        mounted () {
            this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
            this.dateTo = moment().endOf('month').format('YYYY-MM-DD');
        },
        data() {
            return {
                sort: [{label: this.$i18n.t('fields.list_sortName'), by: 'name'}],
                orderSchoolTransactions: [
                    {label: this.$i18n.t('fields.list_orderBySchoolTransactionsAsc'), by: 'asc'},
                    {label: this.$i18n.t('fields.list_orderBySchoolTransactionsDesc'), by: 'desc'}
                ],
                periods: ['day', 'week', 'month'],
                courses: [],
                form: {
                    sort: null,
                    name: "",
                    status: 'active',
                    accountStatus: "",
                    dateFrom: null,
                    dateTo: null,
                    address: "",
                    courses: null,
                    orderSchoolTransactions: null
                },
                dateFrom: null,
                dateTo: null,
                accountStatuses: [
                    'active',
                    'blocked'
                ],
                accountStatusNames: {
                    active: this.$i18n.t('fields.fields_statusActive'),
                    blocked: this.$i18n.t('fields.fields_statusBlocked'),
                }
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        name: null,
                        status: 'active'
                    };
                }
            },
            'form.sort' () {
                this.updateList()
            },
            'form.name'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
            'form.accountStatus'() {
                this.updateList()
            },
            'form.courses'() {
                this.updateList()
            },
            'form.orderSchoolTransactions'() {
                this.updateList()
            },
            'dateFrom'() {
                this.updateList()
            },
            'dateTo'() {
                this.updateList()
            },
        },
        methods: {
            sendForm() {
                if (this.dateFrom) {
                    this.form.dateFrom = moment(this.dateFrom).format('YYYY-MM-DD');
                }
                if (this.dateTo) {
                    this.form.dateTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
                this.$emit(
                    'search',
                    Object.assign({}, this.form, {
                        sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null,
                        orderSchoolTransactions: _.has(this.form, 'orderSchoolTransactions.by')
                            ? this.form.orderSchoolTransactions.by
                            : null,
                    })
                );
            },
            setPeriod (range) {
                this.dateFrom = moment().startOf(range).format('YYYY-MM-DD');
                this.dateTo = moment().endOf(range).format('YYYY-MM-DD');
            },
            resetResults () {
                this.form.sort = null;
                this.form.courses = null;
                this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
                this.dateTo = moment().endOf('month').format('YYYY-MM-DD');
                this.form.status = 'active';
                this.form.accountStatus = "";
                this.form.name = "";
                this.form.address = "";
                this.form.orderSchoolTransactions = null;
                this.$nextTick(() => {
                    this.$emit('search', this.form)
                } );
            },
            getTypeName (type) {
                return this.typesNames[type];
            },
            getAccountStatusName(status) {
                return this.accountStatusNames[status];
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isShowCourseSelect () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport || this.user.type === 'admin';
            }
        }
    }
</script>

<style scoped lang="scss">
    .fields {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
    }

    .fields__element {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        box-sizing: border-box;
        width: 100%;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
        @include media($xlg) {
            width: 50%;
        }
    }

    .fields__element:nth-child(odd) {
        @include media($xlg) {
            padding-right: 40px;
        }
    }

    .fields__element:last-child {
        margin-bottom: 0;
    }

    .fields__element--fluid {
        width: auto;
    }

    .fields__input {
        min-width: 0;
        flex: 1 1 auto;
        margin-bottom: 0;
    }

    .fields__element--period {
        @include media($xlg) {
            display: flex;
            align-items: center;
            padding: 0;
            width: 100%;
        }
    }

    .fields__divider {
        text-align: center;
        @include media($md) {
            margin: 0 $space-x-small;
        }
    }

    .fields__label {
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        min-width: 6.5em;
        @include media($md) {
            text-align: right;
        }
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .fields__label--small {
        @include media($xlg) {
            min-width: 5em;
        }
    }

    .fields__period-buttons-container {
        display: flex;
        flex-wrap: wrap;
        @include media($xlg) {
            margin: 0 20px 0 0;
            flex-wrap: nowrap;
            &:last-child {
                margin-right: 0;
            }
        }
    }

    .fields__period-buttons-container:before {
        content: '';
        display: none;
        margin-right: 20px;
        min-width: 6.5em;
        @include media($md) {
            display: block;
        }
        @include media($xlg) {
            display: none;
        }
    }

    .fields__period-button {
        white-space: nowrap;
        text-align: center;
        flex: 1 1 auto;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        margin: 0 20px;
        @include media($xlg) {
            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>
